module.exports = __webpack_public_path__ + "img/footer_img2-light.198913ec.png";